import { baseUrl, config } from "./constGlobals";
import axios from "axios";
import { loungesBaseUrl, rolesBaseUrl } from "./constServices";
// @ts-ignore
import { trackUserAction } from "@viuti/recursos";

export const getEmployeesService = async (includeInactive = false, includePending = false) => {
  const params = new URLSearchParams();
  if (includeInactive) params.append('includeInactive', 'true');
  if (includePending) params.append('includePending', 'true');
  const query = params.toString();
  const url = `${baseUrl}/team-members${query ? `?${query}` : ''}`;
  const ingresa_vista_empleados = 40;
  trackUserAction(ingresa_vista_empleados);
  const response: IResponse = await axios
    .get(url, config)
    .then((res) => res.data);
  return response;
};

export const getApiSites = async () => {
  try {
    const axiosInstance = (await import("./axiosInstance")).default;
    const response = await axiosInstance.get(
      `${loungesBaseUrl}/lounges`
    );
    return {
      isSuccess: true,
      ...response.data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message: error?.response?.data?.message || "Error al obtener las sedes",
      data: null,
    };
  }
};

export const getLocalSchedulesService = async (idLounge: number) => {
  try {
    const axiosInstance = (await import("./axiosInstance")).default;
    const response = await axiosInstance.get(
      `${loungesBaseUrl}/schedules?IdLounge=${idLounge}`
    );
    return {
      isSuccess: true,
      ...response.data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener el horario del local",
      data: [],
    };
  }
};

export const getEmployeeInfoService = async (idEmployee: number) => {
  const url = `${baseUrl}/info?idEmployee=${idEmployee}`;
  const ingresa_vista_empleado = 41;
  trackUserAction(ingresa_vista_empleado);
  try {
    const response = await axios.get(url, config).then((res) => {
      return res.data;
    });
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener la información del empleado",
      data: null,
    };
  }
};

export const getPositionsService = async () => {
  const url = `${rolesBaseUrl}`;
  try {
    const response: IResponse = await axios
      .get(url, config)
      .then((res) => res.data);
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message: error?.response?.data?.message || "Error al obtener los roles",
      data: [],
    };
  }
};

export const getEmployeeServicesService = async (idEmployee: number) => {
  const url = `${baseUrl}/services?idEmployee=${idEmployee}`;
  try {
    const response = await axios.get(url, config).then((res) => {
      return res.data;
    });
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message || "Error al obtener los servicios",
      data: [],
    };
  }
};

export const getAllServicesService = async () => {
  const url = `${baseUrl}/all-services`;
  try {
    const response: IResponse = await axios.get(url, config).then((res) => {
      return res.data;
    });
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message || "Error al obtener los servicios",
      data: [],
    };
  }
};

export const getEmployeeStatsService = async (idEmployee: number) => {
  const url = `${baseUrl}/statistics?idEmployee=${idEmployee}`;

  try {
    const response: IResponse = await axios
      .get(url, config)
      .then((res) => res.data);
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message:
        error?.response?.data?.message || "Error al obtener las estadísticas",
      data: null,
    };
  }
};

export const getEmployeeLoyaltyDataService = async (idEmployee: number) => {
  const url = `${baseUrl}/loyalty?idEmployee=${idEmployee}`;
  try {
    const response = await axios.get(url, config).then((res) => res);
    return {
      isSuccess: true,
      ...response.data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener la información del empleado",
      data: null,
    };
  }
};

export const getSalesReportService = async (
  idEmployee: number,
  startPeriod: string,
  endPeriod: string
) => {
  const url = `${baseUrl}/sales-report?idEmployee=${idEmployee}&dateFrom=${startPeriod}&dateTo=${endPeriod}`;
  try {
    const response = await axios.get(url, config).then((res) => res.data);
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener el reporte de ventas",
      data: null,
    };
  }
};

export const getServicesTableReportService = async (
  idEmployee: number,
  startPeriod: string,
  endPeriod: string
) => {
  const url = `${baseUrl}/sales-report/detailed?idEmployee=${idEmployee}&dateFrom=${startPeriod}&dateTo=${endPeriod}`;
  try {
    const response = await axios.get(url, config).then((res) => res.data);
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener el reporte de ventas",
      data: null,
    };
  }
};

export const getConsumptionReportService = async (
  idEmployee: number,
  startPeriod: string,
  endPeriod: string
) => {
  const url = `${baseUrl}/sales-report/consumption?idEmployee=${idEmployee}&dateFrom=${startPeriod}&dateTo=${endPeriod}`;
  try {
    const response = await axios.get(url, config).then((res) => res.data);
    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message ||
        "Error al obtener el reporte de consumo",
      data: null,
    };
  }
};

export const getScheduleEmployeeService = async (idEmployee: number) => {
  const url = `${baseUrl}/schedules?idEmployee=${idEmployee}`;
  try {
    const response: IResponse = await axios.get(url, config).then((res) => {
      return res.data;
    });

    return {
      isSuccess: true,
      ...response,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      message:
        error?.response?.data?.message || "Error al obtener los horarios",
      data: null,
    };
  }
};
